(function (window) {
  'use strict';

  function getPageX(e) {
    if (e.type.indexOf('touch') === 0) {
      return e.touches[0].pageX;
    }

    return e.pageX;
  }

  function handleDrag(e) {
    // Elements.
    const dragElement = e.target;
    const container = dragElement.parentNode;
    const resizeElement = container.querySelector('.js-image-comparison-resize');

    // Classes.
    const dragClass = 'js-draggable';

    // Values used by calculations.
    const dragWidth = dragElement.offsetWidth;
    const xPosition = dragElement.getBoundingClientRect().left + document.body.scrollLeft + dragWidth - getPageX(e);
    const containerOffset = container.getBoundingClientRect().left + document.body.scrollLeft;
    const containerWidth = container.offsetWidth;
    const minLeft = containerOffset + 10;
    const maxLeft = containerOffset + containerWidth - dragWidth - 10;

    // State.
    let dragging = false;

    // The user is moving the draggable element.
    function handleDragMove(e) {
      if (!dragging) {
        dragging = true;

        requestAnimationFrame(function () {
          let leftValue = getPageX(e) + xPosition - dragWidth;

          // Constrain the draggable element to only move within the container.
          if (leftValue < minLeft) {
            leftValue = minLeft;
          } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
          }

          const widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

          dragElement.style.left = widthValue;
          resizeElement.style.width = widthValue;

          dragging = false;
        });
      }
    }

    // The user has let go.
    function stopDrag(e) {
      container.removeEventListener('mousemove', handleDragMove);
      container.removeEventListener('touchmove', handleDragMove);
      dragElement.classList.remove(dragClass);
    }

    dragElement.classList.add(dragClass);

    container.addEventListener('mousemove', handleDragMove);
    container.addEventListener('touchmove', handleDragMove);
    container.addEventListener('mouseup', stopDrag);
    container.addEventListener('touchend', stopDrag);

    e.preventDefault();
  }

  // Accessibility keyboard events.
  function keyboardEvent(event) {

    const changePercentage = 5;
    const key = event.key || event.keyCode;
    const comparisonHandle = event.target;
    const imageResize = comparisonHandle.closest('.image-comparison')
      .querySelector('.image-comparison__resize');

    // If the resize has not been used we initialize the property
    // data-comparison and we set it to 50%, If mouse resize was used we get
    // the current value of the resize and we set it on the data-property.
    if (imageResize.style.width === '' || comparisonHandle.style.left === '') {
      // init data-prop
      imageResize.setAttribute('data-comparison', 50);
      comparisonHandle.setAttribute('data-comparison', 50);
    } else {
      // If mouse drag was used we get the current position.
      imageResize.setAttribute('data-comparison', imageResize.style.width.replace('%', ''));
      comparisonHandle.setAttribute('data-comparison', comparisonHandle.style.left.replace('%', ''));
    }

    // Depending on which way the user wants to drag the handle we sum or
    // subtract and set the new value.
    if (key === 'ArrowLeft') {
      const newValue = parseInt(imageResize.getAttribute('data-comparison')) - changePercentage;
      if (newValue >= 0) {
        imageResize.style.width = newValue + '%';
        comparisonHandle.style.left = newValue + '%';
      }
    } else if (key === 'ArrowRight') {
      const newValue = parseInt(imageResize.getAttribute('data-comparison')) + changePercentage;
      if (newValue <= 100) {
        imageResize.style.width = newValue + '%';
        comparisonHandle.style.left = newValue + '%';
      }
    }
  }

  function init() {
    const containers = document.querySelectorAll('.js-image-comparison');

    for (let i = 0; i < containers.length; i++) {
      if (!containers[i].classList.contains('js-component-init')) {
        const handle = containers[i].querySelector('.js-image-comparison-handle');

        handle.addEventListener('mousedown', handleDrag);
        handle.addEventListener('touchstart', handleDrag,{passive: true});
        // add on focus
        handle.addEventListener('focus', () => {
          document.addEventListener('keydown', keyboardEvent);
        });
        handle.addEventListener('focusout', () => {
          document.removeEventListener('keydown', keyboardEvent);
        });

        containers[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
